import styled from "styled-components";

interface TextAreaFieldProps {
	errorMode?: boolean;
}

const TextAreaField = styled.textarea<TextAreaFieldProps>`
	background: #ffffff;
	border: ${props => (props.errorMode ? "2px solid #ba6969" : "2px solid #d8dbe4")};
	box-sizing: border-box;
	box-shadow: 0px 4px 17px rgba(0, 0, 0, 0.08);
	border-radius: 7px;
	padding: 10px;
	margin: 0px;
	width: 100%;
	border: none;
	resize: none;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 165.5%;
	min-height: 160px;
	height: 100%;
	:focus {
		outline: none;
	}
`;

export default TextAreaField;
